import React, { useEffect, useRef } from "react";
import { Hero } from "./components/Hero";
import { Services } from '../Services/Services';
import { Contact } from '../Contact/Contact';
import { Location } from './components/Location';
import { Avis } from './components/Avis';
import 'animate.css';
import { useTitle } from "../../hook/useTitle";

export const Home = () => {

    const sectionsRef = useRef([]);
    const animations = ['fadeInUp', 'fadeInLeft', 'fadeInRight', 'fadeInLeft'];

    useTitle('Découvrir ASF Terrassement')

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const index = sectionsRef.current.findIndex(el => el === entry.target);
                        const animationClass = animations[index] || 'fadeInUp';

                        entry.target.classList.add('animate__animated', `animate__${animationClass}`);
                        entry.target.classList.remove('opacity-0');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
            }
        );
        sectionsRef.current.forEach(section => {
            if (section) observer.observe(section);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <section className="space-y-10">
            <Hero />
            <div
                ref={el => (sectionsRef.current[0] = el)}
                className="opacity-0"
            >
                <Services />
            </div>
            <div
                ref={el => (sectionsRef.current[1] = el)}
                className="opacity-0"
            >
                <Avis />
            </div>

            <div
                ref={el => (sectionsRef.current[2] = el)}
                className="opacity-0"
            >
                <Location />
            </div>

            <div
                ref={el => (sectionsRef.current[3] = el)}
                className="opacity-0"
            >
                <Contact />
            </div>
        </section>
    );
};

export default Home;